import React from "react";
import { Snackbar, Alert } from "@mui/material";

const MessageStatus = ({ message, messageType }) => {
  if (!message) return null;

  return (
    <Snackbar 
      open={!!message} 
      autoHideDuration={3000}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert 
        severity={messageType === "success" ? "success" : "error"}
        sx={{
          fontFamily: '"Plus Jakarta Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
          "& .MuiAlert-message": {
            fontSize: "14px"
          }
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default MessageStatus;
